import { v4 as uuidv4 } from 'uuid';
import db from './db';
import type { Event, Service, GalleryItem } from './types';

// Events
export async function getEvents() {
  return db.events.orderBy('created_at').reverse().toArray();
}

export async function createEvent(event: Omit<Event, 'id' | 'created_at' | 'updated_at'>) {
  const now = new Date().toISOString();
  const newEvent: Event = {
    id: uuidv4(),
    ...event,
    created_at: now,
    updated_at: now
  };

  await db.events.add(newEvent);
  return newEvent;
}

export async function updateEvent(id: string, event: Partial<Event>) {
  const updated = {
    ...event,
    updated_at: new Date().toISOString()
  };

  await db.events.update(id, updated);
  return db.events.get(id);
}

export async function deleteEvent(id: string) {
  await db.events.delete(id);
}

// Services
export async function getServices() {
  return db.services.orderBy('created_at').reverse().toArray();
}

export async function createService(service: Omit<Service, 'id' | 'created_at' | 'updated_at'>) {
  const now = new Date().toISOString();
  const newService: Service = {
    id: uuidv4(),
    ...service,
    created_at: now,
    updated_at: now
  };

  await db.services.add(newService);
  return newService;
}

export async function updateService(id: string, service: Partial<Service>) {
  const updated = {
    ...service,
    updated_at: new Date().toISOString()
  };

  await db.services.update(id, updated);
  return db.services.get(id);
}

export async function deleteService(id: string) {
  await db.services.delete(id);
}

// Gallery
export async function getGalleryItems() {
  return db.gallery.orderBy('created_at').reverse().toArray();
}

export async function createGalleryItem(item: Omit<GalleryItem, 'id' | 'created_at' | 'updated_at'>) {
  const now = new Date().toISOString();
  const newItem: GalleryItem = {
    id: uuidv4(),
    ...item,
    created_at: now,
    updated_at: now
  };

  await db.gallery.add(newItem);
  return newItem;
}

export async function updateGalleryItem(id: string, item: Partial<GalleryItem>) {
  const updated = {
    ...item,
    updated_at: new Date().toISOString()
  };

  await db.gallery.update(id, updated);
  return db.gallery.get(id);
}

export async function deleteGalleryItem(id: string) {
  await db.gallery.delete(id);
}